import React, { useState } from "react";
import { Form, Input, Button, Upload, Row, Col } from "lib/ui";
import {
  PlusOutlined,
  UploadOutlined,
  MinusCircleOutlined,
} from "lib/icons";

const AddBanner = ({ form, onFinish, initialValues }) => {
  const [metaFields, setMetaFields] = useState(
    initialValues.metaFields || [{ key: "", value: "" }]
  );

  const addMetaField = () => {
    setMetaFields([...metaFields, { key: "", value: "" }]);
  };

  const removeMetaField = (index) => {
    setMetaFields(metaFields.filter((_, i) => i !== index));
  };

  const handleMetaFieldChange = (index, field, value) => {
    const next = [...metaFields];
    next[index][field] = value;
    setMetaFields(next);
  };

  return (
    <div className="space-y-1 text-left">
      <Form
        form={form}
        onFinish={(values) => onFinish({ ...values, metaFields })}
        layout="vertical"
        initialValues={initialValues}
        className="space-y-4"
      >
        <Form.Item
          name="title"
          label="Title"
          rules={[{ required: true, message: "Please enter a title." }]}
        >
          <Input placeholder="Banner title" />
        </Form.Item>

        <Form.Item
          name="sortOrder"
          label="Sort order"
          rules={[{ required: true, message: "Please enter sort order." }]}
        >
          <Input placeholder="e.g. 1" inputMode="numeric" />
        </Form.Item>

        <Form.Item
          name="image"
          label="Image"
          valuePropName="fileList"
          getValueFromEvent={(e) => {
            if (Array.isArray(e)) return e;
            return e && e.fileList;
          }}
        >
          <Upload name="logo" action="/upload.do" listType="picture">
            <Button icon={<UploadOutlined />}>Choose file</Button>
          </Upload>
        </Form.Item>

        <div className="rounded-xl border border-dashed border-slate-200 bg-slate-50/50 p-4">
          <p className="mb-3 text-sm font-semibold text-slate-800">Meta fields</p>
          {metaFields.map((metaField, index) => (
            <Row key={index} gutter={[12, 12]} className="mb-3">
              <Col span={11}>
                <Input
                  placeholder="Key"
                  value={metaField.key}
                  onChange={(e) =>
                    handleMetaFieldChange(index, "key", e.target.value)
                  }
                />
              </Col>
              <Col span={11}>
                <Input
                  placeholder="Value"
                  value={metaField.value}
                  onChange={(e) =>
                    handleMetaFieldChange(index, "value", e.target.value)
                  }
                />
              </Col>
              <Col span={2} className="flex items-end justify-end">
                <Button
                  danger
                  type="default"
                  icon={<MinusCircleOutlined />}
                  onClick={() => removeMetaField(index)}
                  aria-label="Remove row"
                />
              </Col>
            </Row>
          ))}
          <Button type="dashed" onClick={addMetaField} icon={<PlusOutlined />} block>
            Add meta field
          </Button>
        </div>

        <Form.Item className="mb-0 pt-2">
          <Button type="primary" htmlType="submit" className="min-w-[8rem]">
            Save banner
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default AddBanner;
